var map = {
	"./buy-comics-digital-comics.png": 5906,
	"./buy-comics-merchandise.png": 5975,
	"./buy-comics-shop-locator.png": 8710,
	"./buy-comics-subscriptions.png": 6565,
	"./buy-dc-power-visa.svg": 3710,
	"./dc-logo-bg.png": 7038,
	"./dc-logo.png": 1285,
	"./footer-bg.jpg": 4392,
	"./footer-facebook.png": 7666,
	"./footer-periscope.png": 2502,
	"./footer-pinterest.png": 6235,
	"./footer-twitter.png": 172,
	"./footer-youtube.png": 6927,
	"./jumbotron.jpg": 1841
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 583;